




























































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  PartnersApi, Partner, MarketsApi, UnitsApi, UnitSchedule,
} from '@compassdigital/foodworks.ts.sdk';
import ScheduleEdit from '@/components/Form/ScheduleSetting/ScheduleEdit/index.vue';
import RotationPreview from '@/components/Form/ScheduleSetting/RotationPreview/index.vue';
import AppModule from '@/store/modules/app';
import UnitsUtil from '@/util/UnitUtil';
import { cloneDeep } from 'lodash';

@Component({
  components: {
    ScheduleEdit,
    RotationPreview,
  },
})
export default class Schedule extends Vue {
  @Prop({}) unitID!: string;

  @PropSync('marketID', {}) marketUserID!: string;

  @PropSync('unitScheduleData', {}) service!: any;

  @PropSync('originalData', {}) serviceOG!: any;

  public edit: boolean = false;

  public partnerUsers: any[] = [];

  public requiredDay: string = '';

  public requireWeek: string = '';

  public saving: boolean = false;

  public partnerList: Partner[] = [];

  public formattedRestaurant: any = {};

  public enableCheck: boolean = false;

  public mounted() {
    this.getPartnerUsers();
    this.restuarantsListById();
  }

  public onCancel() {
    Object.keys(this.service).forEach(k => { this.service[k] = cloneDeep(this.serviceOG[k]); });
    this.edit = false;
  }

  public async onSave() {
    if (this.service.autoSchedule === true) {
      this.service.differentRotation = true;
      if (this.service.weeklyOccurrence.length > 0) {
        this.enableCheck = true;
      }
      if (this.service.weeklyOccurrence.length < 0) {
        this.enableCheck = false;
      }
    }
    if (this.service.autoSchedule === false) {
      this.enableCheck = true;
      this.service.differentRotation = false;
    }
    if (this.service.popupPattern.length > 0 && (this.enableCheck === true)) {
      try {
        this.saving = true;
        const numberStations = parseInt(this.service.numberOfStations, 10);
        const schedule: any = {
          numberOfStations: numberStations,
          autoSchedule: this.service.autoSchedule,
          cuisineExclusions: this.service.cuisineExclusions,
          restaurantExclusions: this.service.restaurantExclusions,
          popupPattern: this.service.popupPattern,
          rotationFrequency: 'weekly',
          weeklyOccurrence: this.service.weeklyOccurrence,
          differentRotation: this.service.differentRotation,
        };
        const api = new UnitsApi(AppModule.apiConfig);
        const schedules = await api.patchUnitById(this.unitID, { schedule });
        Object.keys(this.serviceOG).forEach(k => { this.serviceOG[k] = cloneDeep(schedule[k]); });
        if (schedules.data) {
          this.edit = false;
          this.restuarantsListById();
        }
      } catch (error) {
        console.log('error', error);
      } this.saving = false;
    } else {
      this.requiredDay = 'Can not be left empty';
      this.requireWeek = 'Can not be left empty';
    }
  }

  public async getPartnerUsers() {
    try {
      const api = new MarketsApi(AppModule.apiConfig);
      const fetchedPartners = await api.getPartnersInMarketId(this.marketUserID);
      const updateData: any = UnitsUtil.activePartners(fetchedPartners.data as any);
      this.partnerUsers = updateData;
    } catch (error) {
      console.log('err', error);
    }
  }

  public async restuarantsListById() {
    const serviceInfo = { ...this.service };
    const { restaurantExclusions } = serviceInfo;
    return this.getRestaurant(restaurantExclusions);
  }

  public async getRestaurant(restaurantExclusions: any) {
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const users = await api.getPartners();
      const restaurants: any = users.data;
      const formattedID = UnitsUtil.activePartners(restaurants);
      const formattedName = UnitsUtil.getPartnersListName(
        restaurantExclusions, formattedID,
      );
      this.formattedRestaurant = formattedName;
    } catch (error) {
      //
    }
    return '';
  }
}
